import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axiosInstance from "../axiosinstance";
import { RotateCcw } from "lucide-react";
import "./FlangeDetail.css";
import CloseIcon from "@mui/icons-material/Close";
import LocalOfferOutlinedIcon from "@mui/icons-material/LocalOfferOutlined";
const FlangeDetails = ({ flangeId: propFlangeId, onClose }) => {
  const { flange_id: routeFlangeId } = useParams();
  const flangeId = propFlangeId || routeFlangeId;

  const [flangeData, setFlangeData] = useState(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchFlangeData = async () => {
      try {
        const response = await axiosInstance.get(`/api/view-tag-info/${flangeId}`);
        setFlangeData(response.data.data);
      } catch (error) {
        console.error("Error fetching flange data:", error);
      } finally {
        setLoading(false);
      }
    };

    if (flangeId) fetchFlangeData();
  }, [flangeId]);

  if (loading) return <div className="flange-loading">Loading...</div>;
  if (!flangeData || flangeData.length === 0)
    return <div className="flange-error">No data found.</div>;

  const flangeDetails = flangeData[0];
  const tagNumber = flangeDetails.equipment_number;

  const handleChangeStatus = (id) => {
    const authKey = localStorage.getItem('authKey');
    if (!authKey) {
      navigate('/login');
      return;
    }
    navigate(`/flange-Forms/${id}`);
    if (onClose) onClose(); // Optional: close modal after navigating
  };
  const handleClose = () => {
    const authKey = localStorage.getItem('authKey');
    if (!authKey) {
      navigate('/login');
      return;
    }
    if (onClose) onClose();
};
  return (
    <div className="view-flange-details">
      <div className="flange-details-header">
        <div className="flange-header-left">
          <img src="/jecon.png" alt="Logo" className="view-logo" />
          <div className="tag-inline">
            <LocalOfferOutlinedIcon fontSize="small" />
            <span>
              Tag No.: <strong>{tagNumber || "-"}</strong>
            </span>
          </div>
        </div>
        <button className="close-btn" onClick={handleClose}>
          <CloseIcon />
        </button>
      </div>


      {/* SCROLLABLE SECTION */}
      <div className="view-scroll-mask-frame">
        <div className="view-scrollable-content">
          <div className="view-grid">
            {[
              ["Tag Number", flangeDetails.equipment_number],
              ["Equipment Name", flangeDetails.equipment_name],
              ["Equipment Number", flangeDetails.equipment_number],
              ["Work Order ID", flangeDetails.work_order_id],
              ["Flange Size", flangeDetails.flange_size],
              ["Flange Rating", flangeDetails.rating],
              ["Gasket Type", flangeDetails.gasket_type],
              ["Stud/Nut MOC", flangeDetails.stud_nut_moc],
              ["Bolt Diameter", flangeDetails.bolt_diameter],
              ["Tightening Method", flangeDetails.method_of_tightening],
              ["Lubricant Used", flangeDetails.lubricants_used],
              ["Required Torque", flangeDetails.required_torque],
              ["Achieved Torque", flangeDetails.achieved_torque],
              ["QC Sign", flangeDetails.qc_sign],
              ["Status", flangeDetails.process_name],
            ].map(([label, value], index) => (
              <div key={index} className="view-row">
                <div className="view-label">{label}</div>
                <div className="view-value">{value || "-"}</div>
              </div>
            ))}
          </div>
        </div>
        <div
          aria-hidden="true"
          className="view-scroll-arrow-cover view-scroll-arrow-cover--top"
        />
        <div
          aria-hidden="true"
          className="view-scroll-arrow-cover view-scroll-arrow-cover--bottom"
        />
      </div>

      <div className="flange-action">
        <button
          className="flange-status-button"
          onClick={() => handleChangeStatus(flangeDetails.flange_id)}
        >
          <RotateCcw size={18} style={{ marginRight: "6px" }} />
          Change Status
        </button>
      </div>
    </div>
  );
};

const FlangeRow = ({ label, value }) => (
  <div className="flange-row">
    <span className="flange-label">{label}</span>
    <span className="flange-value">{value || "—"}</span>
  </div>
);

export default FlangeDetails;
